import { Box, TextField, Typography, IconButton, Stack, List, ListItem, ListItemText, Divider } from "@mui/material";
import { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { startToast, updateToastError, updateToastSuccess } from "../../../utils/notification-loading";
import API from "../../../api";

const WhiteList = ({ whitelist = [], setWhitelist }) => {
  const [newIptoAdd, setNewIpToAdd] = useState('')
  const [errorIpAddress, setErrorIpAddress] = useState(false)
  const [loading, setLoading] = useState(false)
  const timeZone = window.sessionStorage.getItem('timezone')

  function validateIP(ip) {
    const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

    if (!ipRegex.test(ip)) return { isValid: false, error: "Invalid IP format. Use format: xxx.xxx.xxx.xxx" };

    return { isValid: true, error: null };
  }

  const handelChangeIpAddress = (e) => {
    const { value } = e.target
    setNewIpToAdd(value)

    if (value.trim() === '') {
      setErrorIpAddress(false)
    } else {
      const validation = validateIP(value)
      setErrorIpAddress(!validation.isValid)
    }
  }

  const TOAddIpOnWhiteList = (ip) => {
    startToast();
    setLoading(true);

    API.setWhitelist({ ip, action: "add" }).then(() => {
      setLoading(false);

      const now = new Date();

      setWhitelist(prev => {
        const idx = prev.findIndex(r => r.ip === ip);
        let next;

        if (idx === -1) {
          next = [...prev, { ip, timeStamp: now }];
        } else {
          next = prev.map(r => r.ip === ip ? { ...r, timeStamp: now } : r);
        }
        return next;
      });

      updateToastSuccess("IP added successfully to the Whitelist");
    })
      .catch(() => {
        setLoading(false);
        updateToastError("Operation failed");
      });
  };

  const TODeleteIpOnWhiteList = (ip) => {
    
    setLoading(true);
    startToast();
    API.setWhitelist({ action: "del", ip: ip }).then((res) => {
      setLoading(false)
      setWhitelist(whitelist.filter((item) => item.ip !== ip));
      updateToastSuccess("Your IP was deleted to the WhiteList");
    }).catch(err => {
      setLoading(false)
      updateToastError("Operation failed");
    })
  }

  return (
    <Stack direction="column" sx={{
      backgroundColor: 'rgba(69, 144, 149, 0.05)',
      borderRadius: 2,
      border: '1px solid rgba(69, 144, 149, 0.1)',
      p: 3,
      height: "60vh"
    }}>
      <Typography sx={{ fontSize: 24, textAlign: "center", fontWeight: 900 }}>
        WhiteList IP Settings
      </Typography>

      <Typography color="primary" sx={{ fontSize: 18, fontWeight: 600, mb: 4, textAlign: "center" }}>
        Manage trusted IP addresses that are allowed to bypass security restrictions
      </Typography>

      <Divider />

      <Typography color="primary" sx={{
        fontSize: 22,
        fontWeight: 700,
        mt: 3,
        textAlign: "center"
      }}>
        Add New IP Address
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-end', justifyContent: 'center' }}>
        <TextField
          label='Enter the IP to be added to the Whitelist'
          sx={{ flex: 1, maxWidth: '400px' }}
          value={newIptoAdd}
          onChange={handelChangeIpAddress}
          error={errorIpAddress}
          helperText={errorIpAddress ? "Enter a valid IP address (e.g., 192.168.1.1)" : ""}
        />

        <IconButton
          disabled={errorIpAddress || loading || newIptoAdd.length === 0}
          onClick={() => TOAddIpOnWhiteList(newIptoAdd)}
          sx={{
            backgroundColor: "#459296",
            color: "#ffffff",
            width: '56px',
            height: '56px',
            '&:hover': {
              backgroundColor: "#52a0a6",
            },
            '&:disabled': {
              backgroundColor: '#444',
              color: '#666',
            },
          }}
        >
          <AddIcon />
        </IconButton>
      </Box>

      <Typography color="primary" sx={{
        fontSize: 22,
        fontWeight: 700,
        textAlign: 'center',
        mt: 2
      }}>
        Current Whitelisted IPs
      </Typography>

      {whitelist.length > 0 ? (
        <List sx={{ overflow: "auto" }}>
          {whitelist.map((item, index) => (
            <ListItem
              key={index}
              sx={{
                mb: 1,
                borderRadius: 1,
                backgroundColor: 'rgba(69, 146, 150, 0.1)',
                border: '1px solid rgba(69, 146, 150, 0.3)',
              }}
              secondaryAction={
                <IconButton
                  edge="end"
                  size="small"
                  onClick={() => TODeleteIpOnWhiteList(item.ip)}
                  sx={{
                    color: '#ff6b6b',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 107, 107, 0.1)',
                    },
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              }
            >
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: 14, color: '#fff', fontWeight: 600 }}>
                    {item.ip}
                  </Typography>
                }
                secondary={
                  <Typography sx={{ fontSize: 11, color: '#888' }}>
                    Added:{' '}
                    {item.timeStamp
                      ? new Date(item.timeStamp).toLocaleString('en-US', {
                        timeZone: timeZone || 'GMT',
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        hour12: false,
                      }).replace(',', ' ')
                      : 'N/A'}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography
          sx={{
            fontSize: 16,
            color: '#888',
            fontStyle: 'italic',
            textAlign: 'center',
            mt: 2,
          }}
        >
          No IP addresses in whitelist yet
        </Typography>
      )}
    </Stack>
  )
};

export default WhiteList;